import { Link, useLocation } from "react-router-dom";
export default function Breadcrumbs() {
    const location = useLocation();

    let currentLink = "";
    const crumbs = location.pathname
        .split("/")
        .filter((crumb) => crumb !== "")
        .map((crumb) => {
            currentLink += `/${crumb}`;

            let c = crumb.split("-");
            c.forEach(function (element, index) {
                c[index] = element.charAt(0).toUpperCase() + element.slice(1);
            });
            crumb = c.join(" ");

            return (
                <div className="crumb" key={crumb}>
                    <Link to={currentLink}>{crumb}</Link>
                </div>
            );
        });
    return (
        <div className="breadcrumbs">
            <ul>{crumbs}</ul>
        </div>
    );
}
